import React from 'react';
import { Link } from 'react-router-dom';
import { Loader2Icon } from 'lucide-react';
type ButtonProps = {
  children: React.ReactNode;
  variant?: 'solid' | 'outline';
  to?: string;
  type?: 'button' | 'submit';
  onClick?: () => void;
  disabled?: boolean;
  loading?: boolean;
  className?: string;
};
export function Button({
  children,
  variant = 'solid',
  to,
  type = 'button',
  onClick,
  disabled,
  loading,
  className = ''
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center gap-2 whitespace-nowrap px-8 py-4 font-slab text-xs font-bold uppercase tracking-[0.25em] transition-[background-color,color,transform] duration-150 ease-out active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50';
  const styles = variant === 'solid' ? 'bg-white text-ink hover:bg-ink-muted' : 'border border-white text-white hover:bg-white hover:text-ink';
  const cls = `${base} ${styles} ${className}`;
  if (to) {
    return <Link to={to} className={cls} data-id="element-46" data-mp="2vxnlw2j045tc">
        {children}
      </Link>;
  }
  return <button type={type} onClick={onClick} disabled={disabled || loading} className={cls} data-id="element-47" data-mp="d28oxhmdsa47">
      {loading && <Loader2Icon className="h-4 w-4 animate-spin" aria-hidden="true" data-id="element-48" data-mp="hzqmkbuy72ww" />}
      {children}
    </button>;
}